import { jsxs as l, jsx as C } from "react/jsx-runtime";
const o = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 10 8",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "mask",
        {
          height: "8",
          id: "mask0_15632_2278",
          maskUnits: "userSpaceOnUse",
          style: { maskType: "luminance" },
          width: "10",
          x: "0",
          y: "0",
          children: /* @__PURE__ */ C(
            "path",
            {
              d: "M9.36897 0.807007H0.917969V7.19301H9.36897V0.807007Z",
              fill: "currentColor"
            }
          )
        }
      ),
      /* @__PURE__ */ l("g", { children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.30393 2.04002L8.81993 1.61502C8.80146 1.59896 8.77997 1.58675 8.75672 1.5791C8.73346 1.57145 8.70892 1.56852 8.68452 1.57047C8.66012 1.57243 8.63636 1.57923 8.61462 1.59049C8.59289 1.60174 8.57361 1.61722 8.55793 1.63602L6.31793 4.43602C6.31299 4.44213 6.30689 4.4472 6.29996 4.45092C6.29304 4.45465 6.28544 4.45695 6.27762 4.45769C6.26979 4.45844 6.2619 4.45761 6.25439 4.45526C6.24689 4.45291 6.23993 4.44909 6.23393 4.44402L5.18593 3.59602C5.16788 3.57939 5.14669 3.56654 5.1236 3.55822C5.10051 3.54991 5.07599 3.5463 5.05148 3.5476C5.02698 3.54891 5.00298 3.5551 4.9809 3.56582C4.95882 3.57654 4.93911 3.59157 4.92293 3.61002L4.49293 4.09602C4.4601 4.13361 4.44321 4.18251 4.44582 4.23235C4.44843 4.28219 4.47035 4.32906 4.50693 4.36302L5.51993 5.28202L6.24693 5.94902C6.25527 5.95653 6.26431 5.96323 6.27393 5.96902L6.92893 5.18702L9.31993 2.30602C9.3516 2.2676 9.36711 2.2184 9.36319 2.16877C9.35927 2.11915 9.33623 2.07298 9.29893 2.04002",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.18997 1.12601C7.88013 0.917831 7.51525 0.806766 7.14197 0.807007H2.80597C2.30558 0.807536 1.82581 1.00648 1.47189 1.36022C1.11796 1.71396 0.918763 2.19361 0.917969 2.69401L0.917969 5.30701C0.919027 5.80723 1.11834 6.28663 1.47224 6.64015C1.82614 6.99367 2.30575 7.19248 2.80597 7.19301H7.14197C7.64219 7.19248 8.1218 6.99367 8.4757 6.64015C8.82959 6.28663 9.02891 5.80723 9.02997 5.30701V3.63601L8.19197 4.64301V5.30701C8.1917 5.5854 8.08099 5.85232 7.88414 6.04918C7.68728 6.24603 7.42036 6.35674 7.14197 6.35701H2.80597C2.52757 6.35674 2.26065 6.24603 2.0638 6.04918C1.86694 5.85232 1.75623 5.5854 1.75597 5.30701V2.69401C1.7565 2.41578 1.86732 2.14912 2.06415 1.95248C2.26098 1.75584 2.52775 1.64527 2.80597 1.64501H7.14197C7.31728 1.64669 7.48931 1.69279 7.64197 1.77901L8.18997 1.12601Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.52185 3.07701H1.77485C1.72844 3.07701 1.68393 3.05858 1.65111 3.02576C1.61829 2.99294 1.59985 2.94843 1.59985 2.90201V2.41401C1.59985 2.3676 1.61829 2.32309 1.65111 2.29027C1.68393 2.25745 1.72844 2.23901 1.77485 2.23901H6.52185C6.56827 2.23901 6.61278 2.25745 6.6456 2.29027C6.67842 2.32309 6.69685 2.3676 6.69685 2.41401V2.90201C6.69685 2.94843 6.67842 2.99294 6.6456 3.02576C6.61278 3.05858 6.56827 3.07701 6.52185 3.07701Z",
            fill: "currentColor"
          }
        )
      ] })
    ]
  }
);
export {
  o as Content
};
